var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Welkom op de home page van LS-Admin")])}
var staticRenderFns = []

export { render, staticRenderFns }